import { Record } from "appworks/model/gameplay/records/record";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { FlingBonusPrizeTier } from "components/bonus/fling/fowl-fling-bonus-component";
import { FowlJackpotBonusResult } from "model/results/fowl-jackpot-bonus-result";
import { SlingoChanceGameSchema, SlingoResponse } from "slingo/integration/slingo-schema";

export class FowlJackpotBonusResultBuilder implements ResultBuilder {
    public filter(data: SlingoResponse, record?: Record, additionalData?: any): boolean {
        return Boolean(data.spinResult?.feature?.prize?.games ?? data.feature?.jackpot);
    }

    public build(record: Record, data: SlingoResponse, additionalData?: any): FowlJackpotBonusResult[] {
        const result = new FowlJackpotBonusResult("jackpot");

        let jackpotData: SlingoChanceGameSchema<{ type: FlingBonusPrizeTier }>;

        if (data.feature?.jackpot?.length > 0) { // slot trigger
            jackpotData = data.feature.jackpot[0];
        } else {
            jackpotData = data.spinResult.feature.prize.games[0].games[0];
        }

        result.cashWon = jackpotData.totalWin * 100;
        result.tier = jackpotData.params.type;

        return [result];
    }
}
